export const TWO_FACTOR_AUTH_TYPES = { AUTHENTICATOR: "1", SMS: "2" };
